module.exports = __webpack_public_path__ + "7d633b652c9b033c2776c332d36e98aa.jpg";


//////////////////
// WEBPACK FOOTER
// ./app/pages/HomePage2/Technology/bottom-left.jpg
// module id = 871
// module chunks = 1